import React, { useState } from 'react';
import './settings.scss';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import UserDTO from '../../../dto/UserDTO';
import { getSettingsData } from '../reducer';
import TextPasswordInput from '../../../components/fields/TextInput/TextPasswordInput';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { createUser, saveUser } from '../actions';
import { getResponseError } from '../../../utils/utils';

export default function UserForm(props) {
  const { data = {}, cancel, loadData = () => {} } = props;
  const { id, role } = data;
  const DTO = new UserDTO();
  const attributes = DTO.getAttributesByName();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    roleList = [],
  } = useSelector(getSettingsData);
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
  } = useForm({
    mode: 'onBlur',
    defaultValues: { ...data, role_id: role ? role.id : '' },
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });

  const save = () => {
    if (!id) {
      dispatch(createUser(getValues())).then(() => {
        loadData();
        cancel();
        successNotification(formatMessage({ id: 'user.create' }), formatMessage({ id: 'user.create.success' }));
      }).catch(response => errorNotification(formatMessage({ id: 'user.create' }), getResponseError(response)));
    } else {
      dispatch(saveUser({
        id,
        data: getValues(),
      })).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'user.save' }), formatMessage({ id: 'user.save.success' }));
      }).catch(response => errorNotification(formatMessage({ id: 'user.save' }), getResponseError(response)));
    }
  };
  return (
    <>
      <div className="settings-form">
        <div className="settings-view-form user-form">
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.username}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextPasswordInput}
            dtoObject={attributes.password}
            variant="material"
            className="mt-3"
            withLabel
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={TextPasswordInput} */}
          {/*  dtoObject={attributes.password_confirmation} */}
          {/*  variant="material" */}
          {/*  className="mt-3" */}
          {/*  withLabel */}
          {/* /> */}
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.role_id}
            variant="material"
            options={(roleList || []).map(item => ({ value: item.id, name: item.name }))}
            withLabel
            className="mt-3"
          />
        </div>
      </div>
      <div className="settings-footer">
        <Button className="clear-show" onClick={save}>{formatMessage({ id: 'app.save' })}</Button>
        <Button className="clear-data" variant="secondary" onClick={cancel}>{formatMessage({ id: 'app.cancel' })}</Button>
      </div>

    </>
  );
}
